import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, keyframes } from 'styled-components';
export var transitionAnimation = function transitionAnimation(transitionProperties) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition-duration: ", ";\n  transition-property: ", ";\n  transition-timing-function: ", ";\n"])), function (_ref) {
    var theme = _ref.theme;
    return theme.transition.duration.value;
  }, transitionProperties, function (_ref2) {
    var theme = _ref2.theme;
    return theme.transition.timing.value;
  });
};
export var keyframesAnimation = function keyframesAnimation(keyframes) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation-duration: ", ";\n  animation-name: ", ";\n  animation-timing-function: ", ";\n"])), function (_ref3) {
    var theme = _ref3.theme;
    return theme.transition.duration.value;
  }, keyframes, function (_ref4) {
    var theme = _ref4.theme;
    return theme.transition.timing.value;
  });
};
export var rotateAnimation = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @keyframes rotateAnimation {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
export var rotateHalfwayAnimation = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-180deg);\n  }\n"])));
export var dashAnimation = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  @keyframes dashAnimation {\n    0% {\n      stroke-dasharray: 1px, 200px;\n      stroke-dashoffset: 0;\n    }\n\n    50% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -15px;\n    }\n\n    100% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -125px;\n    }\n  }\n"])));